import { Spinner } from "@visiblethread/react-components";
import DetailsTable from "components/Modal/ChooseFilesModal/Details/DetailsTable";
import Placeholder from "components/Modal/ChooseFilesModal/Details/Placeholder";
import { UPLOAD_ENTITY_TYPES } from "constants/documentUploads";
import { ReactComponent as FolderIcon } from "icons/folder-closed.svg";
import { LayersIcon } from "lucide-react";
import { string } from "prop-types";
import { Fragment } from "react";
import { useSelector } from "react-redux";
import {
  selectFiles,
  selectIsProcessingFiles,
} from "slices/workspace/selectors";

import TargetName from "./TargetName";

const Details = ({ target }) => {
  const processingFiles = useSelector(selectIsProcessingFiles);
  const selectedFiles = useSelector(selectFiles);

  return (
    <div data-testid="choose-files-modal-body-details">
      <div className="choose_files_modal__body__details__header">
        <Fragment>
          {target === UPLOAD_ENTITY_TYPES.COLLECTIONS ? (
            <LayersIcon width={16} height={16} data-testid="layers-icon" />
          ) : (
            <FolderIcon width={16} height={16} data-testid="folder-icon" />
          )}
          <TargetName target={target} />
        </Fragment>
      </div>
      {processingFiles && <Spinner />}
      {!processingFiles && !selectedFiles.length && <Placeholder />}
      {!!selectedFiles.length && <DetailsTable selectedFiles={selectedFiles} />}
    </div>
  );
};

Details.propTypes = {
  target: string.isRequired,
};

export default Details;
